import { render, staticRenderFns } from "./NsAddressSg.vue?vue&type=template&id=2d432f27&scoped=true&"
import script from "./NsAddressSg.vue?vue&type=script&lang=js&"
export * from "./NsAddressSg.vue?vue&type=script&lang=js&"
import style0 from "./NsAddressSg.vue?vue&type=style&index=0&lang=scss&module=%24x&"
import style1 from "./NsAddressSg.vue?vue&type=style&index=1&id=2d432f27&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$x"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2d432f27",
  null
  
)

export default component.exports